module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("39BMM"))).then(() => parcelRequire('jiQ4W'));